

























































































































































































import Vue from "vue";
import { DateFilterItems, IncompleteVisitsDateFilterItems } from "@/types";
import { mapState } from "vuex";
import { APopoverTarget, APopover } from "@canvas/componentlibrary";
export default Vue.extend({
  components: {
    APopoverTarget,
    APopover,
  },
  props: {
    title: {
      type: String,
    },
    page: {
      type: Number,
    },
    pagelength: {
      type: Number,
    },
    pagecount: {
      type: Number,
    },
    columns: {
      type: Array,
    },
    allcolumns: {
      type: Array,
    },
    isDateFilterRequired: {
      type: Boolean,
      default: false,
    },
    datefilter: {
      type: Object,
    },
    tableType: {
      type: String,
    },
  },
  data: () => {
    return {
      isPageLengthOpen: false,
      isPageOpen: false,
      isDateFilterOpen: false,
      DateFilterItems: DateFilterItems,
      IncompleteVisitsDateFilterItems: IncompleteVisitsDateFilterItems,
      delayedPopupOpener: false,
    };
  },
  inject: ["actionHandler"],
  methods: {
    addColumnToTable(column: string) {
      (this as any).$emit("addColumnToView", column);
    },
    removeColumnFromTable(column: string) {
      (this as any).$emit("removeColumnFromView", column);
    },
    resetColumnOrderInTable(columns: any[]) {
      (this as any).$emit("resetSelectseqInView", columns);
    },
    updateView() {
      (this as any).$emit("saveCurrentView");
    },
    resetView() {
      (this as any).$emit("resetCurrentView");
    },
    setSortOrder() {
      (this as any).$emit("setSortOrderInView");
    },
    goToPage(event: { item: { name: string; displayName: string } }) {
      (this as any).isPageOpen = false;
      (this as any).actionHandler("goToPage", event.item.name);
    },
    pageDecrease() {
      (this as any).isPageOpen = false;
      (this as any).actionHandler("pageDecrease", (this as any).page - 1);
    },
    pageIncrease() {
      (this as any).isPageOpen = false;
      (this as any).actionHandler("pageIncrease", (this as any).page + 1);
    },
    setPageLength(event: { item: { name: string; displayName: string } }) {
      (this as any).isPageLengthOpen = false;
      (this as any).actionHandler("setPageLength", event.item.name);
    },
    setDateFilter(event: {
      item: {
        name: string;
        displayName: string;
        selected: boolean;
      };
    }) {
      (this as any).actionHandler("setDateFilter", event.item);
      if (event.item.name !== "created_at") {
        (this as any).isDateFilterOpen = false;
        (this as any).clearDateFilterInMobile();
      }
    },
    customYearPredictor(
      customizedDate: Date,
      selectedDate: Date | null = null
    ) {
      if (
        selectedDate &&
        selectedDate.getFullYear()! == customizedDate.getFullYear()
      ) {
        return true;
      } else return false;
    },
    isStartDateDisabled(currentDateObject: Date) {
      //allow all dates
      return false;
    },
    isEndDateDisabled(currentDateObject: Date) {
      //disable all dates before startdate if any
      if ((this as any).datefilter.start_date) {
        if (
          currentDateObject.getTime() <
          new Date((this as any).datefilter.start_date).getTime()
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setStartDate(date: Date) {
      if (
        (this as any).datefilterStartDate &&
        (this as any).datefilterEndDate &&
        ((this as any).datefilterEndDate as any).getTime() <
          ((this as any).datefilterStartDate as any).getTime()
      ) {
        (this as any).actionHandler(
          "setDateFilter",
          Object.assign({}, (this as any).datefilter, { end_date: null })
        );
      }
      (this as any).actionHandler(
        "setDateFilter",
        Object.assign({}, (this as any).datefilter, { start_date: date })
      );
    },
    setEndDate(date: Date) {
      (this as any).actionHandler(
        "setDateFilter",
        Object.assign({}, (this as any).datefilter, { end_date: date })
      );
    },
    cancelFilter() {
      (this as any).isDateFilterOpen = false;
      (this as any).clearDateFilterInMobile();
    },
    applyDateFilter() {
      (this as any).actionHandler("applyDateFilter", (this as any).datefilter);
      (this as any).isDateFilterOpen = false;
      (this as any).clearDateFilterInMobile();
    },
    clearDateFilterInMobile() {
      if ((this as any).isOnMobileDevice) {
        (this as any).$store.commit("uiModule/resetMobileAddonOption", null, {
          root: true,
        });
        (this as any).$store.commit(
          "uiModule/setMobileHeader",
          { title: (this as any).$router.currentRoute.meta.header },
          {
            root: true,
          }
        );
      }
    },
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      (this as any).actionHandler("setDateFilter", selected);
      if (selected.name !== "created_at") {
        (this as any).isDateFilterOpen = false;
        (this as any).clearDateFilterInMobile();
      }
    },
    openPopover(option: string) {
      switch (option) {
        case "pagelength":
          (this as any).isPageLengthOpen = !(this as any).isPageLengthOpen;
          (this as any).isPageOpen = false;
          (this as any).isDateFilterOpen = false;
          break;
        case "page":
          (this as any).isPageOpen = !(this as any).isPageOpen;
          (this as any).isPageLengthOpen = false;
          (this as any).isDateFilterOpen = false;
          break;
        case "datefilter":
          (this as any).isDateFilterOpen = !(this as any).isDateFilterOpen;
          (this as any).isPageLengthOpen = false;
          (this as any).isPageOpen = false;
          break;
      }
    },
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
      mobileAddonOption: "mobileAddonOption",
    }),
    isOpenForMobileFilter() {
      //open if isOnMobileDevice and filter option is set or just return the isDateFilterOpen option
      if (
        (this as any).isOnMobileDevice &&
        (this as any).mobileAddonOption.type === "filter" &&
        (this as any).mobileAddonOption.state
      ) {
        return true;
      } else {
        return false;
      }
    },
    dateFilterItems() {
      const dateFilter =
        (this as any).tableType === "history"
          ? (this as any).DateFilterItems
          : IncompleteVisitsDateFilterItems;
      return dateFilter.map((filter: any) => {
        return {
          name: filter.name,
          displayName: filter.display_name,
          selected:
            filter.name === (this as any).datefilter.name ? true : false,
        };
      });
    },
    pagelengthItems() {
      return [10, 25, 50, 100].map((length) => {
        return {
          name: length,
          displayName: length.toString(),
          selected: length === (this as any).pagelength ? true : false,
        };
      });
    },
    pageNumbers() {
      return new Array((this as any).pagecount).fill(0).map((page, i) => {
        return {
          name: i + 1,
          displayName: (i + 1).toString(),
          selected: (this as any).page === i + 1 ? true : false,
        };
      });
    },
    datefilterStartDate() {
      return (this as any).datefilter.start_date
        ? new Date((this as any).datefilter.start_date)
        : null;
    },
    datefilterEndDate() {
      return (this as any).datefilter.end_date
        ? new Date((this as any).datefilter.end_date)
        : null;
    },
  },
});
